/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beantragebefreiungrentenversicherung2Inputs */



/**

* @param {_Field_Beantragebefreiungrentenversicherung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beantragebefreiungrentenversicherung2 = /** @type {((inputs?: _Field_Beantragebefreiungrentenversicherung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beantragebefreiungrentenversicherung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Befreiung der Rentenversicherung beantragt")
});
export { _field_beantragebefreiungrentenversicherung2 as "_field_beantrageBefreiungRentenversicherung" }